export const RouteNames = {
    WAITING_LIST_DETAILS: "waiting-list-lead-details",
    CAPACITY_LEAD_DETAILS: "capacity-lead-details",
    CONTACT: "contact",
    ZIPCODE: "zip-code",
    BOOKING: "booking"
};

export const isFreeFeature = (currentPath: string): boolean => {
    const freePaths = [
        RouteNames.WAITING_LIST_DETAILS,
        RouteNames.CONTACT,
        RouteNames.ZIPCODE,
        RouteNames.BOOKING,
        RouteNames.CAPACITY_LEAD_DETAILS
    ];
    return freePaths.some((subPath) => currentPath.includes(subPath));
};

export const isVPPartherFeature = (currentPath: string): boolean => {
    const freePaths = [RouteNames.BOOKING, RouteNames.CAPACITY_LEAD_DETAILS];
    return freePaths.some((subPath) => currentPath.includes(subPath));
};

export const isBookingFeature = (currentPath: string): boolean => {
    const freePaths = [RouteNames.BOOKING];
    return freePaths.some((subPath) => currentPath.includes(subPath));
};
